<style src='@/resources/styles/overlay.css' scoped></style>

<template>
        <div class="overlay">
            <div class="contents">
                <div class='spirit-guide'></div>
                <h1>{{text}}</h1>
                <h3 v-if="loadingStatus !== ''">{{loadingStatus}}</h3>
            </div>
        </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Overlay',
      props: {
          text: String,
      },
      computed: {
          ...mapGetters(['state', "loadingStatus", "loadingProgress", "filters"]),
      }
  }
</script>